export default "__VITE_ASSET__9fee81c9__"